import { rankFeature, topRanking } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line",
  down: "ri-arrow-down-line",
  new: "ri-fire-line",
  flat: "ri-subtract-line",
};

const trendColor: Record<string, string> = {
  up: "text-accent-400",
  down: "text-primary-300",
  new: "text-accent-400",
  flat: "text-background-400",
};

export default function TopRanking() {
  return (
    <section id="top-ranking" className="w-full bg-primary-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="Heat Ranking"
          title="热度 TOP 榜 · 点击与讨论双排序"
          desc="榜单每 10 分钟刷新一次，点击最高、讨论最多的爆料优先置顶呈现。"
          tone="dark"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* 榜首特写 */}
          <div className="lg:col-span-4">
            <div className="overflow-hidden rounded-lg border border-primary-800 bg-primary-900/50">
              <div className="h-56 overflow-hidden md:h-64">
                <img
                  src={rankFeature.image}
                  alt="黑料每日热度排行榜首封面"
                  title="黑料每日 TOP榜榜首 - 热度排行最醒目"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="rounded-full bg-accent-500 px-3 py-1 font-label text-xs font-semibold tracking-wide text-primary-950">
                  NO.1 榜首
                </span>
                <h3 className="mt-4 font-heading text-xl font-bold text-background-50 md:text-2xl">
                  {rankFeature.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-background-300">{rankFeature.desc}</p>
                <p className="mt-4 font-label text-xs tracking-wide text-accent-400">{rankFeature.meta}</p>
              </div>
            </div>
          </div>

          {/* 榜单列表 */}
          <div className="flex flex-col gap-2 lg:col-span-8">
            {topRanking.map((item) => (
              <article
                key={item.rank}
                className="group flex items-center gap-3 rounded-lg border border-primary-800/70 bg-primary-900/30 px-3 py-3 transition-colors hover:border-primary-700 hover:bg-primary-900/70 md:gap-5 md:px-5 md:py-4"
              >
                <span
                  className={`flex h-10 w-10 shrink-0 items-center justify-center font-label text-xl font-semibold md:h-12 md:w-12 md:text-2xl ${
                    item.rank <= 3 ? "text-accent-400" : "text-background-400"
                  }`}
                >
                  {String(item.rank).padStart(2, "0")}
                </span>

                <div className="min-w-0 flex-1">
                  <h3 className="truncate font-heading text-sm font-semibold text-background-50 transition-colors group-hover:text-accent-300 md:text-base">
                    <a href="#headlines">{item.title}</a>
                  </h3>
                  <div className="mt-1.5 flex flex-wrap items-center gap-3 text-xs">
                    <span className="rounded-full bg-primary-800/80 px-2.5 py-0.5 text-background-200">
                      {item.tag}
                    </span>
                    <span className="flex items-center gap-1 text-background-400">
                      <i className="ri-chat-3-line" />
                      {item.discussion}
                    </span>
                  </div>
                </div>

                <div className="hidden w-28 shrink-0 md:block">
                  <div className="h-1.5 w-full overflow-hidden rounded-full bg-primary-800">
                    <div
                      className="h-full rounded-full bg-accent-500"
                      style={{ width: `${item.heatPercent}%` }}
                    />
                  </div>
                </div>

                <div className="flex shrink-0 items-center gap-2">
                  <span className="font-label text-base font-semibold text-accent-400 md:text-lg">
                    {item.heat}
                  </span>
                  <span className={`flex h-5 w-5 items-center justify-center ${trendColor[item.trend]}`}>
                    <i className={`${trendIcon[item.trend]} text-sm`} />
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}